import { connect } from 'react-redux';
import { IState } from '../../store';

import { ITechnicalCharacterCommercialLandProps, TechnicalCharacterCommercialLand } from './index';

function mapStateToProps(state: IState): ITechnicalCharacterCommercialLandProps {
  return {
    offer: state.offerData.offer,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TechnicalCharacterCommercialLandContainer = connect<ITechnicalCharacterCommercialLandProps, any, any>(
  mapStateToProps,
)(TechnicalCharacterCommercialLand);
